import { Injectable, Inject, NgZone } from '@angular/core';
import { SharepointService } from '../services/sharepoint.service';
import { IMapper, MapperCONFIG  } from '../model/mapper';
import { IMapperPaging } from '../model/mapperPaging';
import { TranslateService } from '@ngx-translate/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';


@Injectable()
export class RepositoryService extends BaseTranslation {

    protected mapper: IMapperPaging;
    constructor(protected spService: SharepointService,translate: TranslateService,ngZone:NgZone, @Inject(MapperCONFIG) mapper?: IMapperPaging) {
       
        super(translate,ngZone);
        this.mapper = mapper;
    }

    public getItemById(webUrl: string, listName: string, itemId: number, onSuccess, onError, onNoAvailableData)
    {
      this.spService.getById(webUrl,listName,itemId).subscribe({
        next: (response) => {

            if (response != null) {
                try {
                    onSuccess(this.mapper.convertItem(response));
                }
                catch (err) {
                    onError(err);
                }
            }
            else {
                onNoAvailableData();
            }

        },
        error: (error) => {

            this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
                if (error != null && error.get_message!=null && error.get_message() != null && error.get_message().toLowerCase().indexOf(this.translate.instant('common.sharePointItemNotExist').toLowerCase()) > -1) {
                    onNoAvailableData();
                }
                else {
                    onError(error);
                } 
           
               });
                 
        }
      });
    }

    public getItemByIdWithAttachment(webUrl: string, listName: string, itemId: number, onSuccess, onError, onNoAvailableData)
    {
      this.spService.getByIdAttachment(webUrl,listName,itemId).subscribe({
        next: (response) => {

            if (response != null) {
                try {
                    onSuccess(this.mapper.convertItem(response));
                }
                catch (err) {
                    onError(err);
                }
            }
            else {
                onNoAvailableData();
            }

        },
        error: (error) => {
            this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
                if (error != null && error.get_message!=null && error.get_message() != null && error.get_message().toLowerCase().indexOf(this.translate.instant('common.sharePointItemNotExist').toLowerCase()) > -1) {
                    onNoAvailableData();
                }
                else {
                    onError(error);
                } 
           
               });     
        }
      });
    }
    
    public getItems(webUrl: string, listName: string, camlQuery: string, onSuccess, onError, onNoAvailableData , mapper: IMapper =null, folderPath?: string,includes? : string) {

        this.spService.getItemsByFilter(webUrl, listName, camlQuery,folderPath,includes).subscribe({

            next: (response) => {

                if (response != null && response.get_count() != 0) {
                    try {
                        if(mapper == null)
                        {
                         onSuccess(this.mapper.convertListItems(response));
                        }
                        else
                        {
                          onSuccess(mapper.convertListItems(response));
                        }
                    }
                    catch (err) {
                        onError(err);
                    }
                }
                else {
                    onNoAvailableData();
                }

            },
            error: (error) => {
                onError(error);
            }

        });
    }


    public getItemsPaging(webUrl: string, listName: string, camlQuery: string, onSuccess, onError, onNoAvailableData , mapper: IMapper =null, folderPath?: string,includes? : string) {

        this.spService.getItemsByFilterPaging(webUrl, listName,camlQuery,folderPath,includes).subscribe({

            next: (response) => {

                if (response != null && response.items.get_count() != 0) {
                    try {
                        if(mapper == null)
                        {
                         onSuccess(this.mapper.convertListItemsPaging(response));
                        }
                        else
                        {
                          onSuccess(this.mapper.convertListItemsPaging(response));
                        }
                    }
                    catch (err) {
                        onError(err);
                    }
                }
                else {
                    onNoAvailableData();
                }

            },
            error: (error) => {
                onError(error);
            }

        });
    }

    public getLoggedInUserName(webUrl: string, onSuccess, onError, onNoAvailableData) {
        this.spService.getCurrentUserLoginName(webUrl).subscribe({

            next: (response) => {

                if (response != null) {
                    try {
                        onSuccess(response);
                    }
                    catch (err) {
                        onError(err);
                    }
                }
                else {
                    onNoAvailableData();
                }

            },
            error: (error) => {
                onError(error);
            }

        });
    }

    public deleteListItems(webUrl: string, listName: string, camlQuery: string, onSuccess, onError) {
        this.spService.deleteListItems(webUrl, listName, camlQuery).subscribe({

            next: (response) => {

               
                    try {
                        onSuccess(response);
                    }
                    catch (err) {
                        onError(err);
                    }
                
                
            },
            error: (error) => {
                onError(error);
            }
        });
    }

    public insertListItems(webUrl: string, listName: string, items: Array<any>, onSuccess, onError) {
        this.spService.insertListItems(webUrl, listName, items).subscribe({
            next: (response) => {

                try {
                        onSuccess(response);
                    }
                    catch (err) {
                        onError(err);
                    }
                
                
            },
            error: (error) => {
                onError(error);
            }
        });
    }

    /*public getProcessGroupsItems(webUrl: string, listName: string, camlQuery: string, onSuccess, onError, onNoAvailableData) {
        this.spService.getItemsByFilter(webUrl, listName, camlQuery).subscribe({

            next: (response) => {

                if (response != null && response.get_count() != 0) {
                    try {
                        onSuccess(response);
                    }
                    catch (err) {
                        onError();
                    }
                }
                else {
                    onNoAvailableData();
                }

            },
            error: (error) => {
                onError();
            }

        });
    }*/
    
}
